export interface PricingTier {
  id: 'basic' | 'pro' | 'pro-plus' | 'custom';
  name: string;
  price: string;
  period: string;
  badge?: string;
  features: readonly string[];
  ctaLabel: string;
}

export const PRICING_TIERS: readonly PricingTier[] = [
  {
    id: 'basic',
    name: 'Basic',
    price: '€750',
    period: '/ jaar',
    features: ['Basis app', 'Smart Planner+', '50 stuks materieel', '1 live event', '1 actieve gebruiker'],
    ctaLabel: 'Neem Basic',
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '€1.550',
    period: '/ jaar',
    badge: 'Meest gekozen',
    features: ['Basis app', 'Smart Planner+', '200 stuks materieel', '2 live events', '2 actieve gebruikers'],
    ctaLabel: 'Neem Pro',
  },
  {
    id: 'pro-plus',
    name: 'Pro+',
    price: '€2.450',
    period: '/ jaar',
    features: ['Basis app', 'Smart Planner+', '400 stuks materieel', '3 live events', '5 actieve gebruikers'],
    ctaLabel: 'Neem Pro+',
  },
  {
    id: 'custom',
    name: 'Custom',
    price: 'Vanaf €750',
    period: '/ jaar',
    features: ['Aantal materieel op maat', 'Aantal actieve gebruikers op maat', 'Extra live events', 'Extra opties op maat'],
    ctaLabel: 'Vraag offerte',
  },
];
